<div class="wrapper">
  @if (guestOrganizations$ | async; as guestOrganizations) {
    <app-filter
      name="guest-organizations"
      idKey="id"
      labelKey="COMMON.ORGANIZATION"
      icon="apartment"
      [value]="filters.guestOrganizationId"
      [findWith]="findGuestOrganization"
      [filterWith]="filterGuestOrganizations"
      [displayWith]="getOrganizationName"
      [options]="guestOrganizations"
      (clear)="setGuestOrganizationId(null)"
      (optionSelected)="setGuestOrganizationId($event)"
    ></app-filter>
  }

  @if (attendees$ | async; as attendees) {
    <app-filter
      name="attendees"
      idKey="email"
      labelKey="COMMON.ATTENDEE"
      icon="person"
      [value]="filters.attendeeId"
      [findWith]="findAttendee"
      [filterWith]="filterAttendees"
      [displayWith]="getAttendeeName"
      [options]="attendees"
      (clear)="setAttendeeId(null)"
      (optionSelected)="setAttendeeId($event)"
    ></app-filter>
  }

  <!--  @if (speakers$ | async; as speakers) {-->
  <!--    <app-multi-filter-->
  <!--      name="speakers"-->
  <!--      labelTranslationKey="COMMON.SPEAKERS"-->
  <!--      icon="record_voice_over"-->
  <!--      idKey="name"-->
  <!--      [values]="filters.speakerIds"-->
  <!--      [displayWith]="getSpeakerName"-->
  <!--      [displaySelected]="displaySelectedSpeakers"-->
  <!--      [options]="speakers"-->
  <!--      (valueChange)="setSpeakerIds($event)"-->
  <!--      (clear)="setSpeakerIds([])"-->
  <!--    ></app-multi-filter>-->
  <!--  }-->

  <mat-chip
    [color]="isDateRangeSelected(filters) ? 'accent' : 'primary'"
    [highlighted]="isDateRangeSelected(filters)"
    (click)="resetDateRange()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
  >
    <div class="chip-content">
      <mat-icon fontIcon="calendar_month"></mat-icon>
      <span class="label clickable">
        {{ isDateRangeSelected(filters) ? (filters.startDate | date) + ' - ' + (filters.endDate | date) : ('COMMON.DATE' | translate) }}
      </span>
      @if (isDateRangeSelected(filters)) {
        <button matChipRemove (click)="resetDateRange()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
      <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
    </div>
  </mat-chip>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isDateRangeOverlayOpen"
    (backdropClick)="isDateRangeOverlayOpen = false"
  >
    <div class="overlay-container">
      <mat-form-field>
        <mat-label translate="COMMON.DATE_RANGE"></mat-label>
        <mat-date-range-input [rangePicker]="dateRangePicker">
          <input matStartDate [placeholder]="'COMMON.START_DATE' | translate" [ngModel]="startDate" (ngModelChange)="setStartDate($event)" />
          <input matEndDate [placeholder]="'COMMON.END_DATE' | translate" [ngModel]="endDate" (ngModelChange)="setEndDate($event)" />
        </mat-date-range-input>
        <mat-hint align="end">{{ 'COMMON.DATE_FORMAT_HINT' | translate }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
      </mat-form-field>
      <button mat-button translate="COMMON.APPLY" (click)="setDateRange()"></button>
    </div>
  </ng-template>

  <mat-checkbox [ngModel]="filters.showOnlyPastMeetings" (ngModelChange)="setShowOnlyPastMeetings($event)">
    {{ 'CALLS.SEARCH.SHOW_ONLY_PAST_MEETINGS' | translate }}
  </mat-checkbox>

  @if (anyFiltersApplied(filters)) {
    <div class="clear-all-container">
      <button class="clear-all-button" mat-button (click)="reset()">
        <mat-icon>close</mat-icon>
        {{ 'COMMON.CLEAR_ALL' | translate }}
      </button>
    </div>
  }
</div>
